import React from "react";
import NavbarRozhana from "./NavbarRozhana";
import Navbar from "../../../Navbar/Navbar";
import ScroollTableRozhana from "./ScroollTableRozhana";
import TableParaKompanya from "./TableParaKompanya";
import FooterOfRozhana from "./FooterOfRozhana";
import { ProductConsumer } from "../../../Context/AddProWakel";
import FooterOfPandK from "./FooterOfPandK";
const AllRozhana = (props) => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { JK_paradan, JK_kompanyakan } = value;
          return (
            <>
              <div>
                <Navbar />
                <div className="row">
                  <div className="col-lg-10 col-sm-12 col-md-12 mt5">
                    {props.JK_paradan || props.JK_kompanyakan == true ? (
                      <TableParaKompanya />
                    ) : (
                      <ScroollTableRozhana />
                    )}
                  </div>
                  <div className="col-lg-2 col-md-none col-sm-none d-sm-none d-md-none d-lg-flex">
                    <NavbarRozhana />
                  </div>
                </div>
                <div className="row" style={{ backgroundColor: "#2C3539" }}>
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    {JK_kompanyakan || JK_paradan ? (
                      <FooterOfPandK />
                    ) : (
                      <FooterOfRozhana />
                    )}
                  </div>
                </div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};
export default AllRozhana;
